import { LineStyle, PolylineProps } from '@editor/interfaces/canvas'
import { CircleAnchorIcon } from '@infraloop/common'

export const DISTANCE_LABEL_STYLES: Partial<PolylineProps> = {
  label: {
    styles: {
      backgroundColor: '#88DF41',
    },
  },
  line: {
    color: '#f00',
    thickness: 0.002,
  },
  lineOutline: {
    style: LineStyle.Solid,
    color: '#888',
    thickness: 0.00025, // make it thinner than line to counter the effect of outline being multiplied to always make it thicker than line
  },
  vertexAnchors: {
    visible: false,
    depthTest: false,
    depthWrite: false,
    color: '#333',
    icon: CircleAnchorIcon.MOVE,
    iconColor: 'white',
    outlineOpacity: 0,
    outlineColor: 'yellow',
  },
  isOutlineContrastingColor: true,
}

export const DISTANCE_LABEL_STYLES_EDITING: Partial<PolylineProps> = {
  ...DISTANCE_LABEL_STYLES,
  vertexAnchors: {
    ...DISTANCE_LABEL_STYLES.vertexAnchors,
    color: '#f00',
  },
}

export const DISTANCE_LABEL_STYLES_WORKING: Partial<PolylineProps> = {
  ...DISTANCE_LABEL_STYLES,
  vertexAnchors: { ...DISTANCE_LABEL_STYLES.vertexAnchors, color: 'orange' },
}

export const DISTANCE_LABEL_STYLES_HOVERING: Partial<PolylineProps> = {
  ...DISTANCE_LABEL_STYLES,
  vertexAnchors: {
    ...DISTANCE_LABEL_STYLES.vertexAnchors,
    visible: true,
    outlineOpacity: 1,
    scale: (DISTANCE_LABEL_STYLES.vertexAnchors?.scale || 1) * 1.3,
    iconScale: (DISTANCE_LABEL_STYLES.vertexAnchors?.iconScale || 1) * 1.3,
    hoverScale: (DISTANCE_LABEL_STYLES.vertexAnchors?.hoverScale || 1) * 1.3,
  },
}
